import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ou-sommes-nous",
  class: "py-5 bg-light"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactLocation',
  setup(__props) {

// No JavaScript logic needed.

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "container" }, [
      _createElementVNode("div", { class: "text-center mb-5" }, [
        _createElementVNode("h2", { class: "display-5 fw-bold" }, "Contact et Accès"),
        _createElementVNode("p", { class: "lead text-muted" }, "Retrouvez-nous facilement et consultez nos horaires d'ouverture.")
      ]),
      _createElementVNode("div", { class: "row align-items-center g-4" }, [
        _createElementVNode("div", { class: "col-lg-7" }, [
          _createElementVNode("div", { class: "map-container shadow rounded overflow-hidden" }, [
            _createElementVNode("iframe", {
              src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2894.493353597565!2d0.1039965154922616!3d43.21178617913878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a9c9a7e6b8f3a1%3A0x6e8f1b3f2e4c2b9a!2s3B%20Rue%20Georges%20N%C3%A9risson%2C%2065430%20Soues!5e0!3m2!1sfr!2sfr!4v1660838458933!5m2!1sfr!2sfr",
              width: "100%",
              height: "450",
              style: {"border":"0"},
              allowfullscreen: "",
              loading: "lazy",
              referrerpolicy: "no-referrer-when-downgrade"
            })
          ])
        ]),
        _createElementVNode("div", { class: "col-lg-5" }, [
          _createElementVNode("div", { class: "card border-0 shadow-sm" }, [
            _createElementVNode("div", { class: "card-body p-4 text-center" }, [
              _createElementVNode("ul", { class: "list-unstyled mb-0" }, [
                _createElementVNode("li", { class: "d-inline-flex align-items-start mb-4" }, [
                  _createElementVNode("i", { class: "bi bi-geo-alt-fill text-primary fs-3 me-3" }),
                  _createElementVNode("div", { class: "text-start" }, [
                    _createElementVNode("h5", { class: "mb-1" }, "Adresse"),
                    _createElementVNode("span", null, [
                      _createTextVNode("3 bis rue Georges Nerisson"),
                      _createElementVNode("br"),
                      _createTextVNode("65430 Soues")
                    ])
                  ])
                ]),
                _createElementVNode("li", { class: "d-inline-flex align-items-start mb-4" }, [
                  _createElementVNode("i", { class: "bi bi-telephone-fill text-primary fs-3 me-3" }),
                  _createElementVNode("div", { class: "text-start" }, [
                    _createElementVNode("h5", { class: "mb-1" }, "Téléphone"),
                    _createElementVNode("span", null, "05.62.94.84.85")
                  ])
                ]),
                _createElementVNode("li", { class: "d-inline-flex align-items-start" }, [
                  _createElementVNode("i", { class: "bi bi-clock-fill text-primary fs-3 me-3" }),
                  _createElementVNode("div", { class: "text-start" }, [
                    _createElementVNode("h5", { class: "mb-1" }, "Horaires"),
                    _createElementVNode("span", null, [
                      _createTextVNode("Du Lundi au Vendredi"),
                      _createElementVNode("br"),
                      _createTextVNode("7h30 – 18h30")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}
}

})